import { graphql, useStaticQuery } from 'gatsby'

export const useGlobalNavigationEntity = () => {
  const { hygraph } = useStaticQuery(graphql`
    query GlobalNavigationEntity {
      hygraph {
        globalNavigation(where: { id: "cll0egz3d9d0f0b1b9vjvpht4" }, stage: PUBLISHED) {
          package {
            linkListing {
              packageId
              icon {
                url
              }
              name
              copy
              link
              isBlank
            }
          }
          feature {
            linkGroupListing {
              groupId
              headline
              linkListing {
                label
                link
                isBlank
              }
            }
          }
          industry {
            linkListing {
              label
              link
              isBlank
            }
            indexLink
          }
          interview {
            linkListing {
              thumbnail {
                url
              }
              title
              link
              isBlank
            }
            indexLink
          }
          caseStudy {
            linkListing {
              thumbnail {
                url
              }
              title
              link
              isBlank
            }
            indexLink
          }
          seminar {
            id
            linkListing {
              label
              link
              isBlank
            }
            indexLink
            recommend {
              thumbnail {
                url
              }
              subTitle
              title
              summary
              link
              buttonLabel
              isBlank
            }
          }
          ebook {
            linkListing {
              label
              link
              isBlank
            }
            indexLink
            recommend {
              thumbnail {
                url
              }
              subTitle
              title
              summary
              link
              buttonLabel
              isBlank
            }
          }
          support {
            label
            link
            isBlank
          }
          operationalSupport {
            linkListing {
              label
              link
              isBlank
            }
            thumbnail {
              url
            }
            thumbnailLink
          }
          spec {
            label
            link
            isBlank
          }
        }
      }
    }
  `)
  return hygraph.globalNavigation
}
